import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import GetGatheringForFullPublicHeaderDocument from "src/api/graphql/__generated__/documents/GetGatheringForFullPublicHeaderDocument";

const useGatheringInfoFullPublic = (
	gatheringId: string,
	{
		fetchPolicy = "cache-first",
	}: {
		fetchPolicy?: "cache-and-network" | "cache-first";
	} = {},
) => {
	const { data, refetch, loading } = useQuery(GetGatheringForFullPublicHeaderDocument, {
		variables: {
			input: {
				gatheringId,
			},
		},
		fetchPolicy,
	});

	const addonsNonNull = useMemo(() => {
		return (
			data?.getGathering?.addons?.map((addon) => {
				if (addon) {
					const { label, icon, url, variant, backgroundColor, ...rest } = addon;
					return {
						label: label ?? undefined,
						icon: icon ?? undefined,
						url: url ?? undefined,
						variant: variant ?? undefined,
						backgroundColor: backgroundColor ?? undefined,
						...rest,
					};
				} else {
					return null;
				}
			}) ?? [].filter((addon) => addon !== null)
		);
	}, [data?.getGathering?.addons]);

	return {
		gathering: { ...data?.getGathering, addons: addonsNonNull },
		refetch,
		loading,
	};
};

export type GatheringPublicPreviewGatheringInfo = ReturnType<
	typeof useGatheringInfoFullPublic
>["gathering"];

export default useGatheringInfoFullPublic;
